import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, forwardRef, isValidElement, useContext, useMemo, useRef } from 'react';
import { Combobox as HeadlessCombobox } from '@flywire/react-headlessui';
import { cx } from '../../utils/cx';
import { findChildRecursively } from '../../utils/findChildRecursively';
import { ComboboxError } from './Error';
import { Field } from './Field';
import { Input } from './Input';
import { Label } from './Label';
import { Option } from './Option';
import { Options } from './Options';
const ComboboxContext = createContext({
    inputRef: { current: null },
    floatingLabel: true
});
export const useComboboxContext = () => {
    return useContext(ComboboxContext);
};
export const useComboboxClasses = ({ className }) => {
    return cx('group/combobox flex flex-col gap-1 relative', className);
};
const ComboboxComponent = forwardRef(({ className, children, ...rest }, ref) => {
    const classes = useComboboxClasses({ className });
    const inputRef = useRef(null);
    const floatingLabel = useMemo(() => {
        return findChildRecursively(children, child => {
            if (isValidElement(child) &&
                child.type.displayName) {
                return child.type.displayName === 'Label';
            }
            return false;
        });
    }, [children]);
    const contextValue = useMemo(() => ({
        inputRef,
        floatingLabel
    }), [floatingLabel]);
    return (_jsx(ComboboxContext.Provider, { value: contextValue, children: _jsx(HeadlessCombobox, { ref: ref, className: classes, ...rest, children: children }) }));
});
ComboboxComponent.displayName = 'Combobox';
const Combobox = ComboboxComponent;
Combobox.Error = ComboboxError;
Combobox.Field = Field;
Combobox.Input = Input;
Combobox.Label = Label;
Combobox.Option = Option;
Combobox.Options = Options;
export { Combobox };
//# sourceMappingURL=Combobox.js.map